import { SearchInput } from "@swivl-mono/ui";
import React from "react";

interface Props {
  onFocus?: any;
  onBlur?: any;
  name?: string;
  onChange?: any;
  value?: any;
  placeholder?: any;
}
export function NavBarSearch(props: Props): React.ReactNode {
  return (
    <SearchInput
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      name={props.name}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  );
}
